// test2370
(2370 && 0);
